import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import { AppSidebar } from "@/components/app-sidebar";
import { CommandPalette } from "@/components/CommandPalette";
import { PageTitleProvider } from "@/components/PageTitleContext";
import { SiteHeader } from "@/components/site-header";
import { useAuth } from "@/auth/useAuth";
import {
  SidebarInset,
  SidebarProvider,
} from "@/components/ui/sidebar";
import {
  applyAppearance,
  DEFAULT_UI_FONT,
  DEFAULT_UI_THEME,
} from "@/lib/appearance";

export function AppLayout() {
  const { user, signOut } = useAuth();
  const [time, setTime] = useState(new Date());
  const [signingOut, setSigningOut] = useState(false);
  const [commandOpen, setCommandOpen] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    // Clear legacy dark-mode overlay so Appearance themes own the chrome.
    document.documentElement.removeAttribute("data-mode");
    document.documentElement.classList.remove("dark");
    localStorage.removeItem("is_dark_mode");

    applyAppearance(
      user?.ui_theme || DEFAULT_UI_THEME,
      user?.ui_font || DEFAULT_UI_FONT
    );
  }, [user?.ui_theme, user?.ui_font]);

  const handleSignOut = async () => {
    setSigningOut(true);
    try {
      await signOut();
    } finally {
      setSigningOut(false);
    }
  };

  const formattedTime = time.toLocaleString(undefined, {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <SidebarProvider
      style={{
        "--sidebar-width": "calc(var(--spacing) * 72)",
        "--header-height": "calc(var(--spacing) * 12)",
      }}
    >
      <AppSidebar
        variant="inset"
        onSignOut={handleSignOut}
        signingOut={signingOut}
      />
      <PageTitleProvider>
        <SidebarInset>
          <SiteHeader
            onSearch={() => setCommandOpen(true)}
            formattedTime={formattedTime}
          />
          <div className="flex flex-1 flex-col">
            <Outlet />
          </div>
        </SidebarInset>
      </PageTitleProvider>

      <CommandPalette open={commandOpen} onOpenChange={setCommandOpen} />
    </SidebarProvider>
  );
}
